import { animate, state, style, transition, trigger } from '@angular/animations';
import { ChangeDetectorRef, Component, HostBinding, Input, OnInit } from '@angular/core';
import {IsActiveMatchOptions, NavigationEnd, Router} from '@angular/router';
import { Module } from '../../models/module.model';
import { NavItem } from './navItem';


@Component({
  selector: 'app-menu-list-item',
  templateUrl: './menu-list-item.component.html',
  styleUrls: ['./menu-list-item.component.scss'],
  animations: [
    trigger('indicatorRotate', [
      state('collapsed', style({transform: 'rotate(0deg)'})),
      state('expanded', style({transform: 'rotate(180deg)'})),
      transition('expanded <=> collapsed',
        animate('225ms cubic-bezier(0.4,0.0,0.2,1)')
      ),
    ])
  ]
})
export class MenuListItemComponent implements OnInit{
  expanded!: boolean;
  @HostBinding('attr.aria-expanded') ariaExpanded = this.expanded;
  @Input() item: NavItem | undefined;
  @Input() depth: number | undefined;
  @Input() modulesActives:Module[]=[];

  constructor(//public navService: NavService,
              public router: Router,
              private cd: ChangeDetectorRef,

              ) {
    // this.router.isActive('/pippo', true);
    // this.router.isActiveMatchOptions({paths: 'subset', queryParams: 'subset', fragment: 'ignored', matrixParams: 'ignored'});

    if (this.depth === undefined) {
      this.depth = 0;
    }
    this.router.events.subscribe((e) => {
      if (e instanceof NavigationEnd) {
        cd.detectChanges();
      }
    });


  }

  hasActiveModule(moduleCode: string): boolean{

    return this.modulesActives.some(m=>m.code === moduleCode && m.active);
  }


  onItemSelected(item: NavItem | undefined): void {
    if (!item) {
      return;
    }
    if (!item.children || !item.children.length) {
      void this.router.navigate([item.route]);
      //this.navService.closeNav();
    }
    if (item.children && item.children.length) {
      this.expanded = !this.expanded;
    }
  }

  ngOnInit(): void {
    const options: IsActiveMatchOptions = {
      paths: this.item?.exactPath ? "exact" : "subset",
      fragment: 'exact',
      matrixParams: 'exact',
      queryParams: 'ignored'
    };

    if (this.item?.route) {
      if (this.router.isActive(this.item.route, options)) {
        this.expanded = true;
      } else {
        this.expanded = false;
      }
    }
  }

}



